import ExpandMore from "@mui/icons-material/ExpandMore"
import MatAccordion, {
  AccordionProps as MatAccordionProps,
} from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"

import React, { FC, ReactNode, SyntheticEvent, useState } from "react"

import { Switch, SwitchProps } from "src/components/common/switch"

import { create } from "src/helpers/bem"

import styles from "./Accordion.module.scss"

const bem = create(styles, "Accordion")

export type AccordionClassNames = {
  root?: string
  wrapper?: string
  tab?: string
  label?: string
  content?: string
  details?: string
}

export type AccordionProps = {
  id: string
  detailsClassName?: string
  label: ReactNode | string
  subLabel?: ReactNode | string
  classNames?: AccordionClassNames
  description?: string
  switch?: SwitchProps
  colorVariant?: "primary" | "secondary" | "base" | "primary-yellow"
} & MatAccordionProps

export const Accordion: FC<AccordionProps> = ({
  id,
  detailsClassName,
  label,
  classNames,
  description,
  children,
  defaultExpanded,
  onChange,
  colorVariant = "primary",
  ...props
}) => {
  const [expanded, setExpanded] = useState<string | boolean>(
    defaultExpanded ? id : false,
  )

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      onChange?.(event, isExpanded)
      setExpanded(isExpanded ? panel : false)
    }

  return (
    <div>
      <MatAccordion
        className={bem("", undefined, classNames?.root)}
        {...props}
        expanded={expanded === id}
        onChange={handleChange(id)}
      >
        <AccordionSummary
          aria-controls={`${id}-content`}
          className={bem("tab__wrapper", colorVariant, classNames?.wrapper)}
          expandIcon={<ExpandMore className={bem("expand", colorVariant)} />}
          id="panel1bh-header"
          classes={{
            content: classNames?.content,
          }}
        >
          <div className={bem("tab", undefined, classNames?.tab)}>
            {typeof label === "object" ? (
              label
            ) : (
              <h4
                className={bem(
                  "tab__headline",
                  colorVariant,
                  classNames?.label,
                )}
              >
                {label}
              </h4>
            )}
            {description && (
              <h4 className={bem("tab__description")}>{description}</h4>
            )}
          </div>
          {props.switch ? (
            <Switch {...props.switch} className={bem("switch")} />
          ) : null}
        </AccordionSummary>
        <AccordionDetails className={detailsClassName}>
          {children}
        </AccordionDetails>
      </MatAccordion>
    </div>
  )
}
